type AuthTokenGetter = () => string | null

let getToken: AuthTokenGetter = () => null

export const setAuthTokenGetter = (getter: AuthTokenGetter): void => {
  getToken = getter
}

export const getAuthToken = (): string | null => getToken()
